import React, { FunctionComponent } from "react"
import { HeartIconModels } from "./HeartIcon.models"

export const HeartIcon: FunctionComponent<HeartIconModels> = ({
  width,
  ...props
}) => (
  <svg
    width={width}
    viewBox="0 0 26 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.7265 15.5391C22.1645 14.9689 21.4972 14.5165 20.7628 14.2079C20.0284 13.8992 19.2412 13.7404 18.4463 13.7404C17.6513 13.7404 16.8641 13.8992 16.1297 14.2079C15.3953 14.5165 14.728 14.9689 14.166 15.5391L12.9997 16.7221L11.8334 15.5391C10.6982 14.3878 9.15854 13.741 7.55315 13.741C5.94775 13.741 4.40811 14.3878 3.27293 15.5391C2.13774 16.6905 1.5 18.252 1.5 19.8803C1.5 21.5085 2.13774 23.07 3.27293 24.2214L4.43926 25.4043L12.9997 34.0865L21.5602 25.4043L22.7265 24.2214C23.2887 23.6514 23.7348 22.9746 24.0391 22.2298C24.3434 21.4849 24.5 20.6865 24.5 19.8803C24.5 19.074 24.3434 18.2756 24.0391 17.5307C23.7348 16.7859 23.2887 16.1091 22.7265 15.5391V15.5391Z"
      stroke="#FF3939"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.7265 8.4622C22.1645 7.89194 21.4972 7.43958 20.7628 7.13094C20.0284 6.82231 19.2412 6.66345 18.4463 6.66345C17.6513 6.66345 16.8641 6.82231 16.1297 7.13094C15.3953 7.43958 14.728 7.89194 14.166 8.4622L12.9997 9.64513L11.8334 8.4622C10.6982 7.31086 9.15854 6.66405 7.55315 6.66405C5.94775 6.66405 4.40811 7.31086 3.27293 8.4622C2.13774 9.61354 1.5 11.1751 1.5 12.8033C1.5 14.4316 2.13774 15.9931 3.27293 17.1444L4.43926 18.3274L12.9997 27.0096L21.5602 18.3274L22.7265 17.1444C23.2887 16.5745 23.7348 15.8977 24.0391 15.1528C24.3434 14.408 24.5 13.6096 24.5 12.8033C24.5 11.997 24.3434 11.1987 24.0391 10.4538C23.7348 9.70894 23.2887 9.03219 22.7265 8.4622V8.4622Z"
      stroke="#FF3939"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.7265 2.7122C22.1645 2.14194 21.4972 1.68958 20.7628 1.38094C20.0284 1.07231 19.2412 0.913452 18.4463 0.913452C17.6513 0.913452 16.8641 1.07231 16.1297 1.38094C15.3953 1.68958 14.728 2.14194 14.166 2.7122L12.9997 3.89513L11.8334 2.7122C10.6982 1.56086 9.15855 0.914049 7.55315 0.914049C5.94775 0.914049 4.40811 1.56086 3.27293 2.7122C2.13774 3.86354 1.5 5.42508 1.5 7.05332C1.5 8.68155 2.13774 10.2431 3.27293 11.3944L4.43926 12.5774L12.9997 21.2596L21.5602 12.5774L22.7265 11.3944C23.2887 10.8245 23.7348 10.1477 24.0391 9.40283C24.3434 8.65797 24.5 7.85959 24.5 7.05332C24.5 6.24705 24.3434 5.44867 24.0391 4.70381C23.7348 3.95894 23.2887 3.28219 22.7265 2.7122Z"
      fill="#FF3939"
      stroke="#FF3939"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
